import React from 'react';
import { TypographyVariant } from 'src/components-dummy';
import {
  EmptyCardsContainer,
  EmptyHeaderStyled,
  ImagesRow,
  ImageStyled,
} from './CampaignPreview.styles';
import ProductTile from 'src/assets/product-tile-email-campaign.png';

export const EmptyStatePreview = (): JSX.Element => {
  return (
    <EmptyCardsContainer>
      <EmptyHeaderStyled variant={TypographyVariant.LargeBold}>
        Campaign Name Header
      </EmptyHeaderStyled>
      <ImagesRow>
        {[...Array(4)].map((_, idx) => (
          <ImageStyled key={idx} src={ProductTile} />
        ))}
      </ImagesRow>
    </EmptyCardsContainer>
  );
};
